import AuthService from "@/services/Auth/AuthService"
import { keycloak, updateKeycloakToken } from '@/main'
import Cookies from 'js-cookie'

const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
const SET_CARTORIO_ID = 'SET_CARTORIO_ID'
const SET_CARTORIO_OBJ = 'SET_CARTORIO_OBJ'
const SET_USER_CARTORIOS = 'SET_USER_CARTORIOS'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const SET_USUARIO = 'SET_USUARIO'
const OPEN_SIDEBAR = 'OPEN_SIDEBAR'
const CHANGE_MODULE = 'CHANGE_MODULE'
const LOGOUT = 'LOGOUT'
const SET_ANALISES = 'SET_ANALISES'
const SET_PRIMEIRO_ACESSO = 'SET_PRIMEIRO_ACESSO'
const SET_LAST_PATH = 'SET_LAST_PATH'

export default {
  namespaced: true,
  state: {
    cartorio_id: null,
    primeiro_acesso: false,
    cartorioObj: null,
    user_cartorios: [],
    usuario: null,
    userToken: null,
    isLoggedIn: false,
    sidebarOpen: false,
    tipoAnalises: [],
    loaderStatus: {
      active: false,
      text: ''
    },
    lastPath: null
  },
  getters: {
    getLoaderStatus: (state) => state.loaderStatus,
    confirmLogin: (state) => state.isLoggedIn,
    isSidebarOpen: (state) => state.sidebarOpen,
    getUser: (state) => state.usuario,
    getCartorioObj: (state) => state.cartorioObj,
    getTipoAnalises: (state) => state.tipoAnalises,
    getUserToken: (state) => state.userToken,
    getCartorioId: (state) => state.cartorio_id,
    // NOVO
    getTokenIDRC: () => getTokenIDRC(),

    getCartorioPrimeiroAcesso: (state) => state.primeiro_acesso,
    getUserCartorios: (state) => state.user_cartorios,
    getLastPath: (state) => state.lastPath
  },
  mutations: {
    [SIGNUP_SUCCESS] (state, usuario) {
      state.isLoggedIn = true
      state.usuario = usuario
    },
    [LOGIN_SUCCESS] (state, userToken) {
      state.isLoggedIn = true
      state.userToken = userToken
    },
    [SET_USUARIO] (state, usuario) {
      state.usuario = usuario
    },
    [SET_CARTORIO_ID] (state, cartorioId) {
      state.cartorio_id = cartorioId
    },
    [SET_CARTORIO_OBJ] (state, cartorio) {
      state.cartorioObj = cartorio
    },
    [SET_PRIMEIRO_ACESSO] (state, status) {
      state.primeiro_acesso = !!status ? true : false
    },
    [SET_USER_CARTORIOS] (state, cartorios) {
      state.user_cartorios = cartorios
    },
    [LOGOUT] (state) {
      state.usuario = null
      state.userToken = null
      state.isLoggedIn = false
      state.cartorio_id = null
      state.primeiro_acesso = false
      state.cartorioObj = null
      state.cartorios = []
      state.user_cartorios = []
      sessionStorage.clear()
      localStorage.clear()
      window.localStorage.clear()
    },
    LOADER_ACTIVE (state, status) {
      state.loaderStatus = status
    },
    BODY_CLASS (state, status) {
      let el = document.body

      if (status) {
        el.classList.add('overflow-hidden')
      } else {
        el.classList.remove('overflow-hidden')
      }
    },
    [OPEN_SIDEBAR] (state, status) {
      state.sidebarOpen = status
    },
    [CHANGE_MODULE] (state, status) {
      let lStore = window.localStorage
    },
    [SET_ANALISES] (state, lista) {
      state.tipoAnalises = lista
    },
    [SET_LAST_PATH] (state, path) {
      state.lastPath = path
    }
  },
  actions: {
    setAnalises ({ commit }, lista) {
      commit(SET_ANALISES, lista)
    },
    async check ({ commit }, userToken) {
      let user
      const token = await getTokenIDRC()

      if (token) {
        const res = await AuthService.loginIDRC(token).then((response) => {
          return response.data
        })

        if (res) {
          commit(SET_USUARIO, res.users)
          commit(LOGIN_SUCCESS, res.token)
        }
        return res
      } else {
        if (!userToken) return

        user = await AuthService.checkIsLoggedIn(userToken).then((response) => {
          return response.data
        }).catch(e => {
          console.error("Erro ao checar login.", e)
        })

        if (user) {
          commit(SET_USUARIO, user)
          commit(LOGIN_SUCCESS, userToken)
        }

        return user
      }
    },
    async checkLogin ({ commit }, userId) {
      let user
      const token = await getTokenIDRC()

      if (!token && userId) {
        const res = await AuthService.loginCheck(userId).then((response) => {
          return response.data
        })

        if (res) {
          const userToken = res.token

          commit(LOGIN_SUCCESS, userToken)
          commit(SET_USUARIO, res.usuario)
        }
        return res
      }
    },
    async loginIDRC () {
      // await keycloak.login({ scope: '', locale: 'pt-BR' })
      const params = new URLSearchParams({
        redirectUrl: window.location.href,
        client: 'Sofia'
      })

      window.location.href = `${process.env.VUE_APP_SOFIA_REI_AUTH_URL}/loginIDRC?${params.toString()}`
    },
    async login ({ commit }, userToken) {
      // evitar sessao aberta, fazer a limpeza com logout.
      commit(LOGOUT)

      const usuario = await AuthService.me(userToken).then(resp => resp.data)

      commit(LOGIN_SUCCESS, userToken)
      commit(SET_USUARIO, usuario)

      return usuario
    },
    async logout ({ commit }) {
      commit(LOGOUT)
    },
    async logoutIDRC ({ commit }, userId) {
      const params = new URLSearchParams({
        user: userId,
      })

      window.location.href = `${process.env.VUE_APP_SOFIA_REI_AUTH_URL}/logout?${params.toString()}`

      // if (keycloak && keycloak.token) {
      //   await keycloak.logout({ redirectUri: location.protocol + '//' + location.host + '/login' }).then(() => {
      //     localStorage.removeItem('token-idrc')
      //   })
      // }
    },
    loader ({ commit }, status) {
      commit('BODY_CLASS', status.active)
      commit('LOADER_ACTIVE', status)
    },
    openSidebar ({ commit }, status) {
      commit('BODY_CLASS', status)
      commit(OPEN_SIDEBAR, status)
    },
    changeModule ({ commit }, status) {
      commit(CHANGE_MODULE, status)
    },
    setCartorioId ({ commit }, cartorioId) {
      commit(SET_CARTORIO_ID, cartorioId)
    },
    setCartorioObj ({ commit }, obj) {
      commit(SET_CARTORIO_OBJ, obj)
    },
    setUserCartorios ({ commit }, cartorios) {
      commit(SET_USER_CARTORIOS, cartorios)
    },
    setPrimeiroAcesso ({ commit }, status) {
      commit(SET_PRIMEIRO_ACESSO, status)
    },
    setLastPath ({ commit }, path) {
      commit(SET_LAST_PATH, path)
    }
  }
}
function getTokenIDRC () {
  try {
    const token = window.localStorage.getItem('token-idrc')
    return token
  } catch (e) {
    console.log(e)
  }
}
